import { HTTP_STATUS } from '@brightlocal/api-client';

export const ERROR_PAGE_TYPES = {
  FORBIDDEN_PAGE: HTTP_STATUS.FORBIDDEN,
  NOT_FOUND_PAGE: HTTP_STATUS.NOT_FOUND,
  INTERNAL_SERVER_ERROR_PAGE: HTTP_STATUS.INTERNAL_SERVER_ERROR
} as const;
